import { memo } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from 'src/shared/components/ui/icons/avatar';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { square } from 'src/shared/lib/utils';
import { Organisation } from 'src/shared/types/organisation.types';

type OrgAvatarProps = {
  org?: Organisation;
  size?: number;
  source?: string;
};

function OrgAvatar({ org, size = 20, source = undefined }: OrgAvatarProps) {
  const { role } = useOrg();

  const logo =
    role === 'SALES'
      ? `https://avatar.vercel.sh/${org?.name}.png`
      : org?.logo || `https://avatar.vercel.sh/${org?.name}.png`;

  return (
    <Avatar style={square(size)}>
      {!['SALES'].includes(role) && <AvatarImage alt={org?.name} className="object-contain" src={source || logo} />}
      <AvatarFallback delayMs={1000} className="bg-primary">
        <p style={{ fontSize: `${size * 0.6}px` }} className="text-white">
          {org?.name
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map((word: string) => word[0].toUpperCase())
            .join('')}
        </p>
      </AvatarFallback>
    </Avatar>
  );
}

export default memo(OrgAvatar);
